module.exports = __webpack_public_path__ + "static/media/WS.2b2e95d2.png";